import { render, staticRenderFns } from "./VAppLayout.vue?vue&type=template&id=5025d406"
import script from "./VAppLayout.vue?vue&type=script&lang=js"
export * from "./VAppLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports